import L from "leaflet";

export default {
    associationsCulture: L.icon({
        iconUrl: require("../assets/ic-associations-culture.png"),
        iconSize: [32, 32],
    }),
    associationsEconomique: L.icon({
        iconUrl: require("../assets/ic-associations-economique.png"),
        iconSize: [32, 32],
    }),
    associationsSolidarite: L.icon({
        iconUrl: require("../assets/ic-associations-solidarite.png"),
        iconSize: [32, 32],
    }),
    associationsSport: L.icon({
        iconUrl: require("../assets/ic-associations-sport.png"),
        iconSize: [32, 32],
    }),
    equipementCorbeille: L.icon({
        iconUrl: require("../assets/ic-equipement-corbeille.png"),
        iconSize: [32, 32],
    }),
    equipementsDefibrilateurs: L.icon({
        iconUrl: require("../assets/ic-equipements-defibrilateurs.png"),
        iconSize: [32, 32],
    }),
    equipementsPropeteCanine: L.icon({
        iconUrl: require("../assets/ic-equipements-proprete-canine.png"),
        iconSize: [32, 32],
    })
}
